import React from "react";

import ModalAddImageAnswer from "../components/ModalAddImageAnswer";
import Loading from "app/pages/home/components/Loading";
import { useQuestionForm } from "./useQuestionForm";
import ModalDialogView from "./components/ModalDialogView";

import {
  CognitiveCategoryType,
  CollectionType,
  QuestionType,
  QuizType,
} from "app/types";

type QuestionFormModalProps = {
  collections: CollectionType[];
  open: boolean;
  quiz: QuizType;
  quizId: number;
  question?: QuestionType;
  cognitiveCategories: Array<CognitiveCategoryType>;
  audiometryCategories: CognitiveCategoryType[];
  audioDeviceType: any[];
  audioChannel: any[];
  handleClose: () => void;
  onFinish: (quizId: number) => void;
  setQuestion?: (question: QuestionType) => void;
  returnInArray?: boolean;
};

const QuestionForm: React.FC<QuestionFormModalProps> = ({
  collections,
  open,
  question,
  quiz,
  quizId,
  cognitiveCategories,
  audiometryCategories,
  audioDeviceType,
  audioChannel,
  returnInArray = false,
  onFinish,
  handleClose,
  setQuestion,
}) => {
  const {
    styleInput,
    translate,
    cognitiveInputs,
    showModalAnswersImage,
    sequence,
    selectedType,
    remove,
    register,
    preViewImage,
    onSubmit,
    onClose,
    handleQuestChange,
    handleFileQuestion,
    handleDescChange,
    handleClearQuest,
    fields,
    errors,
    control,
    setValue,
    watch,
    clearImageQuestion,
    clearForm,
    append,
    answers,
    modalAnswersImage,
    answersOld,
    loading,
  } = useQuestionForm({
    handleClose,
    onFinish: () => onFinish(quizId),
    quiz,
    question,
    open,
    returnInArray,
    setQuestion,
  });

  return (
    <>
      <Loading isLoading={loading} />
      <ModalAddImageAnswer
        answers={answers}
        answersOld={answersOld}
        open={modalAnswersImage}
        onClose={onClose}
      />
      <ModalDialogView
        answers={answers}
        append={append}
        clearImageQuestion={clearImageQuestion}
        cognitiveInputs={cognitiveInputs}
        collections={collections}
        control={control}
        setValue={setValue}
        watch={watch}
        errors={errors}
        fields={fields}
        handleClearQuest={handleClearQuest}
        handleDescChange={handleDescChange}
        handleFileQuestion={handleFileQuestion}
        handleQuestChange={handleQuestChange}
        onClose={onClose}
        onSubmit={onSubmit}
        open={open}
        preViewImage={preViewImage}
        register={register}
        quiz={quiz}
        remove={remove}
        selectedType={selectedType}
        sequence={sequence}
        showModalAnswersImage={showModalAnswersImage}
        styleInput={styleInput}
        translate={translate}
        cognitiveCategories={cognitiveCategories}
        audiometryCategories={audiometryCategories}
        audioDeviceType={audioDeviceType}
        audioChannel={audioChannel}
      />
    </>
  );
};

export default QuestionForm;
